import { BladeFile } from '@razorpay/blade/components';

export interface CreateClaimStateType {
  Component_id: string;
  Component_name: string;
  Bill_amount: string;
  Expense_date: string;
  Description: string;
  Files: BladeFile[];
  Claim_id?: string;
  Claim_status?: string;
}

export const CreateClaimInitialState: CreateClaimStateType = {
  Component_id: '',
  Component_name: '',
  Bill_amount: '',
  Expense_date: '',
  Description: '',
  Files: [],
  Claim_id: '',
  Claim_status: '',
};

export const maxProofFilesCount = 4;

export const maxProofFilesSize = maxProofFilesCount * 1024 * 1024;
